// extracted by mini-css-extract-plugin
export default {"paymentTransactionsOperationContentWrapper":"PaymentTransactionsOperationsEditModal_paymentTransactionsOperationContentWrapper__IGOxw"};